<template>
  <div class="row">
    <div class="col-12">
      <div class="card m-b-30">
        <div class="card-header">
          <h5 class="card-title mb-0">Filtri</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-3">
              <input
                type="text"
                v-model="query"
                class="form-control "
                placeholder="Codice/ragione sociale/telefono/email"
              />
            </div>
            <div class="col-3">
              <select class="form-control" v-model="state">
                <option value="">Attive</option>
                <option value="ToBeCharge">Da prendere in carico</option>
                <option value="DocumentationRequest"
                  >Richiesta documentazione</option
                >
                <option value="DocumentationToCheck"
                  >Documentazione da ricevere</option
                >
                <option value="ToBeAssigned">Istruttoria da assegnare</option>
                <option value="ToAccept">Da istruire</option>
                <option value="InProgress">In corso</option>
                <option value="DraftProcessing">Lavorazione bozza</option>
                <option value="OriginalDocumentRequest"
                  >Richiesta documenti originali</option
                >
                <option value="DraftToBeConfirmed">Bozza da accettare</option>
                <option value="ToVerify">Verifica AML e contabile</option>
                <option value="ToBeFixed">Stipula da fissare</option>
                <option value="ToBeStipuled">Da stipulare</option>
                <option value="ToBeInvoiced">Da fatturare</option>
                <option value="ToBeCompleted">Da Lavorare</option>
                <option value="Invoice">Evasa</option>
                <option value="Stopped">Revocata</option>
              </select>
            </div>

            <div class="col-2">
              <select class="form-control" v-model="procedure">
                <option value="">Tutte le procedure</option>
                <option value="procura">Procura</option>
                <option value="tradizionale">Tradizionale</option>
              </select>
            </div>
            <div class="col-2">
              <select
                class="form-control"
                v-model="company"
                v-if="!isInRole('user') && !isInRole('customer')"
              >
                <option value="">Tutte le banche</option>
                <option v-for="c in cuser.companies" :value="c.companyId">{{
                  c.name
                }}</option>
              </select>
            </div>
            <div class="col-2">
              <select
                class="form-control"
                v-model="litigation"
                v-if="!isInRole('user') && !isInRole('customer')"
              >
                <option value="">Tutte i gestori</option>
                <option v-for="c in litigations" :value="c.key">{{
                  c.label
                }}</option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-control" v-model="missingdocumentation">
                <option value="">Tutte</option>
                <option value="true">Documentazione carente</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-6 ">
              <label class="form-label">Data di stipula presunta:</label>
            </div>
            <div class="col-6">
              <label class="form-label">Data scadenza contratto:</label>
            </div>
            <div class="col-3">
              <input
                type="date"
                class="form-control"
                v-model="stipulationdatestart"
              />
            </div>
            <div class="col-3">
              <input
                type="date"
                class="form-control"
                v-model="stipulationdateend"
              />
            </div>

            <div class="col-3">
              <input
                type="date"
                class="form-control"
                v-model="expirationdatestart"
              />
            </div>
            <div class="col-3">
              <input
                type="date"
                class="form-control"
                v-model="expirationdateend"
              />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-6 ">
              <label class="form-label">Data di stipula:</label>
            </div>
            <div class="col-6"></div>
            <div class="col-3">
              <input
                type="date"
                class="form-control"
                v-model="releasedatestart"
              />
            </div>
            <div class="col-3">
              <input
                type="date"
                class="form-control"
                v-model="releasedateend"
              />
            </div>

            <div class="col-3"></div>
            <div class="col-3"></div>
          </div>
          <div class="row mt-2">
            <div
              class="col-2"
              v-if="
                isInRole('superoperator') ||
                  isInRole('operator') ||
                  isInRole('commercialoperator')
              "
            >
              <select
                name="inchargeTo"
                class="form-control"
                v-model="outsourcer"
              >
                <option value="">Tutti</option>
                <option value="outsourcer">Solo outsourcer</option>
                <option value="internal">No outsourcer</option>
              </select>
            </div>

            <div class="col-2" v-if="isInRole('superoperator')">
              <select
                name="inchargeTo"
                class="form-control"
                v-model="inchargeto"
              >
                <option value="">Nessun operatore</option>
                <option
                  v-for="option in operators"
                  v-bind:key="option.userId"
                  v-bind:value="option.userId"
                >
                  {{ option.firstName }} {{ option.lastName }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12 text-right">
              <button class="btn btn-primary-rgba mr-2" v-on:click="filter">
                <i class="feather icon-filter mr-2"></i>Filtra
              </button>

              <button class="btn btn-danger-rgba" v-on:click="resetdata">
                <i class="feather icon-delete mr-2"></i>Elimina filtro
              </button>
              <button
                class="btn btn-secondary-rgba ml-2"
                v-if="isInRole('superoperator') || isInRole('report')"
                v-on:click="exportXlsx"
              >
                <i class="feather icon-file mr-2"></i>Esporta Excel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card m-b-30">
        <div class="card-body">
          <button
            v-if="!isInRole('customer') && !isInRole('readonly')"
            class="btn btn-sm btn-primary-rgba  mb-3"
            @click="$router.push({ name: 'route-contract-new' })"
          >
            <i class="feather icon-file-plus mr-2"></i>Nuovo contratto
          </button>
          <table
            ref="table"
            id="list-contract-table"
            class="table table-hover w-100"
          ></table>
        </div>
      </div>
    </div>
    <a ref="exportA"></a>
  </div>
  <!-- /.col -->
</template>

<script>
import axios from "axios";
import Input from "../../components/Attachments/input.vue";
import Label from "../../components/EditableLabel/Label.vue";

export default {
  computed: {
    cuser() {
      return this.$store.state.user;
    },
  },
  components: { Input, Label },
  data() {
    return {
      litigations: [],
      litigation: "",
      outsourcer: "",
      outsourcers: [],
      tags: [],
      query: "",
      state: "",
      procedure: "",
      company: "",
      inchargeto: "",
      missingdocumentation: "",
      stipulationdatestart: null,
      stipulationdateend: null,
      expirationdatestart: null,
      expirationdateend: null,
      releasedatestart: null,
      releasedateend: null,
      draftdatestart: null,
      draftdateend: null,
      operators: [],
    };
  },
  name: "ContractList",
  beforeMount() {
    var me = this;
    window.ViewMessage = function(id) {
      me.$router.push({
        name: "route-message",
        params: { id: id },
        replace: true,
      });

      return false;
    };
  },

  mounted() {
    var me = this;
    if (localStorage.getItem("contract-list-query"))
      me.query = localStorage.getItem("contract-list-query");

    if (localStorage.getItem("contract-list-state"))
      me.state = localStorage.getItem("contract-list-state");

    if (localStorage.getItem("contract-list-stipulationdatestart"))
      me.stipulationdatestart = localStorage.getItem(
        "contract-list-stipulationdatestart"
      );

    if (localStorage.getItem("contract-list-litigation"))
      me.litigation = localStorage.getItem("contract-list-litigation");
    if (localStorage.getItem("contract-list-stipulationdateend"))
      me.stipulationdateend = localStorage.getItem(
        "contract-list-stipulationdateend"
      );
    if (localStorage.getItem("contract-list-expirationdatestart"))
      me.sexpirationdatestart = localStorage.getItem(
        "contract-list-expirationdatestart"
      );
    if (localStorage.getItem("contract-list-expirationdateend"))
      me.expirationdateend = localStorage.getItem(
        "contract-list-expirationdateend"
      );

    if (localStorage.getItem("contract-list-releasedatestart"))
      me.releasedatestart = localStorage.getItem(
        "contract-list-releasedatestart"
      );
    if (localStorage.getItem("contract-list-releasedateend"))
      me.releasedateend = localStorage.getItem("contract-list-releasedateend");

    if (localStorage.getItem("contract-list-litigation"))
      me.litigation = localStorage.getItem("contract-list-litigation");

    if (localStorage.getItem("contract-list-outsourcer"))
      me.outsourcer = localStorage.getItem("contract-list-outsourcer");

    if (localStorage.getItem("contract-list-procedure"))
      me.procedure = localStorage.getItem("contract-list-procedure");

    if (localStorage.getItem("contract-list-company"))
      me.company = localStorage.getItem("contract-list-company");
    if (localStorage.getItem("contract-list-missingdocumentation"))
      me.missingdocumentation = localStorage.getItem(
        "contract-list-missingdocumentation"
      );
    if (localStorage.getItem("contract-list-inchargeto"))
      me.inchargeto = localStorage.getItem("contract-list-inchargeto");

    axios.get("contract/operators").then((response) => {
      this.operators = response.data;
    });

    axios.get("contract/outsourcer").then((response) => {
      this.outsourcers = response.data;
      setTimeout(this.loaddata, 200);
    });

    if (me.cuser.companies.length > 1) {
      axios
        .get(
          "contract/litigation/" +
            (me.cuser.companies.length > 1
              ? "ALL"
              : me.cuser.companies[0].companyId)
        )
        .then((response) => (this.litigations = response.data));
    }
  },
  methods: {
    edit: function(cid, id) {
      this.$router.push({
        name: "route-contract-edit",
        params: { cid: cid, id: id },
      });
      return false;
    },
    resetdata() {
      this.query = "";
      this.tags = [];
      this.state = "";
      this.litigation = "";
      this.stipulationdatestart = this.stipulationdateend = this.expirationdatestart = this.expirationdateend = this.releasedatestart = this.releasedateend = this.draftdatestart = this.draftdateend = null;

      null;
      this.company = this.procedure = this.operator = this.inchargeto = this.missingdocumentation =
        "";
      axios.get("contract/outsourcer").then((response) => {
        this.outsourcers = response.data;
        this.loaddata();
      });
    },
    exportXlsx: function() {
      var me = this;
      axios
        .get(`contract/excel`, { responseType: "blob" })
        .then(function(result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(
              blob,
              "riscattileasingexport.xlsx"
            );
          } else {
            me.$refs.exportA.href = URL.createObjectURL(blob);
            me.$refs.exportA.download = "riscattileasingexport.xlsx";
            me.$refs.exportA.click();
          }
        });
    },

    isInRole(role) {
      if (this.cuser)
        for (var i = 0; i < this.cuser.roles.length; i++) {
          if (this.cuser.roles[i] == role) {
            return true;
          }
        }
      return false;
    },
    filter() {
      localStorage.setItem("contract-list-pagenumber", 0);
    
      this.loaddata();
    },
    loaddata: function() {
      var me = this;
      var start = 0;
var pagelength = 10;
if(!isNaN(parseInt(localStorage.getItem("contract-list-pagenumber")))){
  start=parseInt(localStorage.getItem("contract-list-pagenumber"))

}
if(!isNaN(parseInt(localStorage.getItem("contract-list-pagelength")))){
  pagelength=parseInt(localStorage.getItem("contract-list-pagelength"))

}
      window["EditAction"] = this.edit;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-contract-table")) {
        $("#list-contract-table")
          .DataTable()
          .destroy();
      }

      var $table = $("#list-contract-table").DataTable({
      displayStart: start,
      pageLength: pagelength,
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/contract/list",
          type: "POST",
          data: function(d) {
            localStorage.setItem("contract-list-query", me.query);           
              localStorage.setItem("contract-list-pagenumber", d.start);    
            localStorage.setItem("contract-list-pagelength", d.length);
            localStorage.setItem("contract-list-tags", JSON.stringify(me.tags));
            localStorage.setItem(
              "contract-list-stipulationdatestart",
              me.stipulationdatestart
            );
            localStorage.setItem(
              "contract-list-stipulationdateend",
              me.stipulationdateend
            );
            localStorage.setItem(
              "contract-list-expirationdatestart",
              me.expirationdatestart
            );
            localStorage.setItem(
              "contract-list-expirationdateend",
              me.expirationdateend
            );
            localStorage.setItem(
              "contract-list-releasedatestart",
              me.releasedatestart
            );
            localStorage.setItem(
              "contract-list-releasedateend",
              me.releasedateend
            );
            localStorage.setItem("contract-list-litigation", me.litigation);
            localStorage.setItem("contract-list-state", me.state);
            localStorage.setItem("contract-list-outsourcer", me.outsourcer);
            localStorage.setItem("contract-list-procedure", me.procedure);
            localStorage.setItem("contract-list-company", me.company);
            localStorage.setItem(
              "contract-list-missingdocumentation",
              me.missingdocumentation
            );
            localStorage.setItem("contract-list-inchargeto", me.inchargeto);

            d.search.value = me.query;
            d.filters = [
              {
                key: "state",
                value: me.state,
              },
              {
                key: "outsourcer",
                value: me.outsourcer,
              },
              {
                key: "litigation",
                value: me.litigation,
              },

              {
                key: "stipulationdate",
                value: me.stipulationdatestart + "|" + me.stipulationdateend,
              },
              {
                key: "expirationdate",
                value: me.expirationdatestart + "|" + me.expirationdateend,
              },
              {
                key: "releasedate",
                value: me.releasedatestart + "|" + me.releasedateend,
              },
              {
                key: "procedure",
                value: me.procedure,
              },
              {
                key: "company",
                value: me.company,
              },
              {
                key: "missingdocumentation",
                value: me.missingdocumentation,
              },
              {
                key: "inchargeto",
                value: me.inchargeto,
              },
            ];

            return JSON.stringify(d);
          },

          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "contractId",
            name: "contractId",
            title: "Ragione sociale",
            render: function(data, type, row, meta) {
              var retval = `
               <span class="badge badge-success capitalize ${
                 row.procedureId
               }">${
                row.procedureId
              }</span> <span class="badge badge-info capitalize">${
                row.ransomId
              } ${row.subRansomId || ""}</span>
             <span class="badge  float-right p-0 mr-2"><img class="img-fluid" style="height:25px"  src="assets/images/logo/${
               row.companyId
             }.svg"/></span>
            <span class="badge badge-info float-right p-2  mr-2">${me.$options.filters.contractState(
              row.state
            )}</span> 
             <h4>${row.code} </h4>
             <h5>${row.companyName}</h5>
              `;

              if (me.isInRole("user")) {
                retval += "<p> Valore di riscatto:<strong class='ml-2 mr-2'>";
                retval += me.$options.filters.toCurrency(row.amount);
                retval += "</strong>";
                retval += "Pagamento riscatto:<strong class='ml-2 mr-2'>";
                retval += row.ransomPayment ? "SI" : "NO";
                retval += "</strong>";

                retval += "</p>";
              }
              retval += "<p>";
              if (row.expirationDate) {
                retval += `<strong title="Scadenza Contratto"><i class="feather icon-alert-triangle mr-2"></i>${me.$options.filters.formatDate(
                  row.expirationDate
                )}</strong><br/>`;
              }
              if (row.releaseDate) {
                retval += `<strong title="Data Stipula"><i class="feather icon-calendar mr-2"></i>${me.$options.filters.formatDate(
                  row.releaseDate
                )}</strong><br/>`;
              }
              if (row.operator) {
                retval += `<span class="text-muted mr-2"><i class="feather icon-user mr-2"></i>${row.operator.firstName} ${row.operator.lastName}</span>`;
              }

              if (row.outSourcerId) {
                var outsourcer = me.outsourcers.filter(
                  (x) => x.userId == row.outSourcerId
                );

                if (outsourcer.length > 0) {
                  retval += `<span class="text-muted"><i class="feather icon-user mr-2"></i>${outsourcer[0].firstName} ${outsourcer[0].lastName}</span>`;
                }
              }
              if (row.litigation != "") {
                retval += `<br/><span class="text-muted mr-2">Gestore contenzioso: ${row.litigation}</span>`;
              }

              retval += "</p>";

              if (row.emailToProcess > 0) {
                retval += `<strong><i class="feather icon-mail mr-2"></i>${
                  row.emailToProcess
                }
              <i class="feather icon-calendar ml-2 mr-2"></i>${me.$options.filters.formatDate(
                row.lastEmailToProcess
              )}</strong>`;
              }

              if (row.missingDocumentation) {
                retval += `<strong class="ml-5 text-danger"><i class="fa fa-file-pdf-o mr-2"></i>DOCUMENTAZIONE CARENTE</strong>`;
              }

              return retval;
            },
          },
          {
            className: "text-right",
            data: "contractId",
            name: "contractId",
            title: "Azioni",
            render: function(data, type, row, meta) {
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${row.companyId}','${row.contractId}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action d-none"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],

        createdRow: function(row, data, dataIndex) {
          // Set the data-status attribute, and add a class
          $(row).addClass("importance importance-" + data.importance);
        },
      });

     
      $table.on("select", function(e, dt, type, indexes) {});
    },
  },
};
</script>
